import { Contact } from '@contacts/interfaces/contact';
import { profileContactInividualFieldConfig } from '@contacts/config/contact_individual';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Profile } from '@core/interfaces/profile';
import store from '@app/store';
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import Select from '@shared/components/forms/inputs/select/select.vue';
import CountriesSelector from '@shared/components/forms/inputs/countries-selector/countries-selector.vue';
import Section from '@shared/components/forms/inputs/section/section.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import { setProp } from '@shared/helpers/operators';

const bpcRouterHelper = new BPCApiRouteHelper();

@Component({
  name: 'bpc-profile-contact',
  components: {
    'bpc-std-form': StdForm,
    'bc-select': Select,
    'bpc-countries-selector': CountriesSelector,
    'bc-section': Section,
    'bc-textarea': Textarea,
    'bpc-datepicker': Datepicker,
  },
})
export default class ProfileContact extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
    profileStdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };
  @Prop({ type: Boolean, default: false }) readonly disabledForm: boolean;
  @Prop(String) readonly subheading: string;

  isSavingForm: boolean = false;
  i = 0;
  public entity: Contact = new Contact();
  public profile: Profile = null;
  public gender = null;
  public disableGender: boolean = false;
  public nationality = null;
  public disableNationality: boolean = false;
  public birthdate = null;
  public disableBirthdate: boolean = false;
  public healthInformation = null;

  get contactIndividualFieldConfig() {
    return profileContactInividualFieldConfig;
  }

  get contactId() {
    return this.$authorizationService.getContactId();
  }

  get canManage() {
    return this.$authorizationService.hasPermissions(['manage_contacts', 'manage_own_contacts']);
  }

  get lang(): string {
    return this.$store.getters['auth/userLang'];
  }

  get profileId(): number {
    return this.$store.getters['auth/profile']({
      tenantId: this.$store.getters['tenant/selectedTenantId'],
    }).id;
  }

  get profileSavePath() {
    return `${bpcRouterHelper.getEntityPath('profile')}/${this.profileId}/language`;
  }

  onFormSaved($event: any = null) {
    this.isSavingForm = false;
  }

  onProfileSaved($event: any) {
    if ($event.data.language !== this.lang) {
      this.$store.commit('auth/updateProfile', $event.data);
      this.$store.commit('auth/setUserLang', $event.data.language);
    }
    this.$router.go(0);
  }

  onModelLoaded($event) {
    this.$nextTick().then(() => {
      this.gender = this.$refs.stdForm.formModel.contactIndividual?.gender;
      this.nationality = this.$refs.stdForm.formModel.contactIndividual?.nationality;
      this.birthdate = this.$refs.stdForm.formModel.contactIndividual?.birthdate;
      this.healthInformation = this.$refs.stdForm.formModel.contactIndividual?.health_information;

      if (this.gender) {
        this.disableGender = true;
      }
      if (this.nationality) {
        this.disableNationality = true;
      }
      if (this.birthdate) {
        this.disableBirthdate = true;
      }
    });
  }

  async onFormSave() {
    this.isSavingForm = true;
    // It is necessary to make async to avoid showing a success message for the second call if the first one fail.
    // Example: Validation of the main form fails hbut the second call is success. This show a success message and confuse the user
    // Making async we don't call the second api call to save the profile language if the first one is not successful

    if (this.gender) {
      this.$refs.stdForm.formModel.contactIndividual.gender = this.gender;
    }
    if (this.nationality) {
      this.$refs.stdForm.formModel.contactIndividual.nationality = this.nationality;
    }
    if (this.birthdate) {
      this.$refs.stdForm.formModel.contactIndividual.birthdate = this.birthdate;
    }
    if (this.healthInformation) {
      this.$refs.stdForm.formModel.contactIndividual.health_information = this.healthInformation;
    }
    await this.$refs.stdForm.saveEntity();

    this.$refs.profileStdForm.saveEntity();
  }

  onSavingEntity(event) {
    this.isSavingForm = event;
  }

  onInputCustomEvent(event) {
    const eventName = event.eventName;
    switch (eventName) {
      case 'selectedCityFromPostalCode':
        // When updating the zip code field, update the city field
        setProp(this.$refs.stdForm?.formModel?.contactDetail, 'city', event.value);
        break;
      case 'selectedCountryFromPostalCode':
        // When updating the zip code field, update the country field
        setProp(this.$refs.stdForm?.formModel?.contactDetail, 'country', event.value.toLowerCase());
        break;
      default:
        break;
    }
  }

  mounted() {
    this.$root.$on('updateContact', event => {
      this.$refs.stdForm.formModel.to_invoice = event.to_invoice === 1;
      this.$refs.stdForm.formModel.when_to_invoice = event.when_to_invoice_value;
    });
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  destroyed() {
    this.$root.$off('updateContact');
  }
}
